// src/components/ChallengeLiveModal.js
import React, { useEffect, useRef, useState } from "react";
import pb from "../lib/pb";
import Peer from "peerjs";
import { useAuth } from "../contexts/AuthContext";

export default function ChallengeLiveModal({ open, onClose, challengeId }) {
  const videoRef = useRef(null);
  const peerRef = useRef(null);

  const { user } = useAuth();
  const [stream, setStream] = useState(null);
  const [isLive, setIsLive] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    if (!open) return;

    console.log("🟢 Live Modal Opened with challengeId:", challengeId);

    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((s) => {
        setStream(s);
        if (videoRef.current) {
          videoRef.current.srcObject = s;
        }
      })
      .catch(console.error);

    return () => {
      if (stream) {
        stream.getTracks().forEach((t) => t.stop());
      }
      if (peerRef.current) {
        peerRef.current.destroy();
        peerRef.current = null;
      }
    };
  }, [open]);

  const startBroadcast = async () => {
  console.log("🚀 startBroadcast payload:", {
    challengeId,
    userId: user?.id,
  });

  if (!challengeId || !user?.id) {
    alert("Missing challengeId or userId");
    console.error("❌ Missing data", { challengeId, user });
    return;
  }

  const res = await fetch("https://api.myfavv.live/start-live", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      challengeId: challengeId,
      userId: user.id,
    }),
  });

  const data = await res.json();

  if (!res.ok) {
    console.error("❌ API error:", data);
    alert(data?.error?.message || "Failed to start broadcast");
    return;
  }

  setSessionId(data.sessionId);

  alert(`
OBS SETTINGS

RTMP URL:
${data.rtmpUrl}

STREAM KEY:
${data.streamKey}
`);
};


  const startLive = async () => {
    if (!user?.peerId || !stream || isLive) return;

    const peer = new Peer(user.peerId);
    peerRef.current = peer;

    peer.on("call", (call) => {
      call.answer(stream);
    });

    peer.on("open", async () => {
      setIsLive(true);
      await startBroadcast();
    });

    peer.on("error", console.error);
  };

  const stopLive = async () => {
    if (peerRef.current) {
      peerRef.current.destroy();
      peerRef.current = null;
    }

    setIsLive(false);

    if (sessionId) {
      await pb.collection("live_sessions").update(sessionId, {
        isLive: false,
      });
      setSessionId(null);
    }
  };

  if (!open) return null;

  return (
    <div className="challenge-live-modal">
      <video ref={videoRef} autoPlay muted playsInline />

      <div className="live-actions">
        {!isLive && <button onClick={startLive}>🔴 Start Live</button>}
        {isLive && <button onClick={stopLive}>⏹ Stop Live</button>}
        <button onClick={onClose}>✖ Close</button>
      </div>
    </div>
  );
}